import { useTheme } from "@emotion/react";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import AlertMessage from "components/react-lib/generic-ui/AlertMessage";
import LabelledOutline from "components/react-lib/generic-ui/LabelledOutline";
import HeaderCell from "components/table/HeaderCell";
import React from "react";

export default function ModelPrice({ model, pricing }) {

  const theme = useTheme();

  const formatPrice = (price) => {
    return `${price.toFixed(2)} $`;
  };

  if (model.type === "text/image") {
    return (
      <LabelledOutline 
        label={model.name}
        rawLabelColor={theme.palette.formLabel.main}
      >
        <Stack spacing={2}>
          <Typography>Text to image model.</Typography>
          <Stack>
            <Typography textAlign="center" fontFamily="'Anton', sans-serif">
              Prices per image
            </Typography>
            <Table>
              <TableBody>
                <TableRow>
                  <HeaderCell align="left">Cost per image</HeaderCell>
                  <TableCell align="right">
                    {formatPrice(model.pricing.cost)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Stack>
        </Stack>
      </LabelledOutline>
    );
  }

  if (model.type === "multimodal/text") {
    return (
      <LabelledOutline 
        label={model.name}
        rawLabelColor={theme.palette.formLabel.main}
      >
        <Stack spacing={2}>
          <Typography>Multi-modal input text generator model.</Typography>
          <Stack>
            <Typography textAlign="center" fontFamily="'Anton', sans-serif">
              Prices per {model.pricing.factor} tokens
            </Typography>
            <Table>
              <TableBody>
                <TableRow>
                  <HeaderCell align="left">Input Token Price</HeaderCell>
                  <TableCell align="right">{model.pricing.input} $</TableCell>
                </TableRow>
                <TableRow>
                  <HeaderCell align="left">Output Token Price</HeaderCell>
                  <TableCell align="right">{model.pricing.output} $</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Stack>
        </Stack>
      </LabelledOutline>
    );
  }

  return <AlertMessage severity="error">Unknown model type.</AlertMessage>;
}
